import { Theme } from 'theme-ui'
import { darken } from '@theme-ui/color'

const buttons: Theme['buttons'] = {
  primary: {
    py: '0.812rem',
    px: 3,
    fontFamily: 'body',
    borderRadius: 's',
    fontSize: '15px',
    outline: 'none',
    // cursor: 'pointer',
    // transition: 'background-color 0.3s',
    '&:hover': {
      bg: darken('primary', 0.1),
    },
    '&:active': {
      bg: darken('primary', 0.2),
    },
    '&:disabled,&[disabled]': {
      cursor: 'not-allowed',
      bg: 'highlight',
      color: 'muted',
    },
  },
  secondary: {
    py: '0.812rem',
    px: 3,
    fontFamily: 'body',
    borderRadius: 's',
    fontSize: '15px',
    outline: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    backgroundColor: 'secondary',
    '&:disabled,&[disabled]': {
      cursor: 'not-allowed',
      bg: 'highlight',
      color: 'muted',
    },
    '&:hover': {
      bg: darken('secondary', 0.1),
    },
    '&:active': {
      bg: darken('secondary', 0.2),
    },
  },
  outline: {
    py: '0.812rem',
    px: 3,
    fontFamily: 'body',
    borderRadius: 's',
    outline: 'none',
    cursor: 'pointer',
    bg: 'transparent',
    border: '1px solid',
    borderColor: 'primary',
    color: 'primary',
    fontWeight: 'normal',
    '&:hover': {
      bg: 'primary',
      color: 'white',
    },
    '&:active': {
      bg: darken('primary', 0.12),
      borderColor: darken('primary', 0.12),
      color: 'white',
    },
    '&:disabled,&[disabled]': {
      cursor: 'not-allowed',
      border: '1px solid',
      borderColor: 'highlight',
      color: 'muted',
      '&:hover': {
        bg: 'unset',
      },
    },
  },
  warning: {
    py: '0.812rem',
    px: 3,
    fontFamily: 'body',
    borderRadius: 's',
    outline: 'none',
    cursor: 'pointer',
    bg: 'transparent',
    transition: 'background-color 0.3s, box-shadow 0.3s',
    boxShadow: 'inset 0 0 0 3px var(--theme-ui-colors-errors, #E03B54)',
    // border: '3px solid',
    // borderColor: 'error',
    color: 'error',
    '&:active': {
      bg: 'gray2',
    },
    '&:disabled,&[disabled]': {
      cursor: 'not-allowed',
      bg: 'highlight',
      boxShadow: 'inset 0 0 0 3px var(--theme-ui-colors-error, #E03B54)',
      color: 'muted',
    },
  },
  destructive: {
    py: '0.812rem',
    px: 3,
    fontFamily: 'body',
    borderRadius: 's',
    outline: 'none',
    cursor: 'pointer',
    bg: 'error',
    color: 'background',
    transition: 'background-color 0.3s',
    '&:active': {
      bg: '#CB374D',
    },
    '&:disabled,&[disabled]': {
      cursor: 'not-allowed',
      bg: 'highlight',
      color: 'muted',
    },
  },
  icon: {
    outline: 'none',
    cursor: 'pointer',
    '&:disabled,&[disabled]': {
      cursor: 'not-allowed',
      color: 'muted',
    },
  },
  link: {
    outline: 'none',
    bg: 'unset',
    color: 'primary',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
}

export default buttons
